import styled from 'styled-components'

export const StyledBackButton = styled.button`
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  color: ${props => props.theme.colors.secondary[500]};
  font-weight: ${props => props.theme.fontWeight.medium};

  svg {
    margin-right: ${props => props.theme.spacing.small};
  }
`
